const normalize = (value = "") => String(value).toLowerCase().trim();

// const KEYWORDS = {
//   PURCHASE_INVOICE_LINE: ["expense", "cost", "inventory", "purchase", "payable"],
//   PAYMENT_VOUCHER_DISBURSEMENT: ["cash", "bank", "wallet", "mobile", "mpesa", "petty cash"],
//   CLIENT_RECEIPT_SETTLEMENT: ["cash", "bank", "wallet", "mobile", "mpesa", "petty cash"],
// };

// const resolveSearchText = (item = {}) => {
//   const category = item.accountCategory || item.categoryName || item.category || "";
//   const subCategory = item.accountCategoryName || item.subCategory || "";
//   return normalize(`${category} ${subCategory}`);
// };

// export const filterAccountSubCategoriesByUseCase = (subCategories = [], useCase) => {
//   if (!Array.isArray(subCategories)) {
//     return [];
//   }

//   const keywords = KEYWORDS[useCase] || [];
//   if (keywords.length === 0) {
//     return subCategories;
//   }

//   const normalizedKeywords = keywords.map(normalize);
//   const filtered = subCategories.filter((item) => {
//     const text = resolveSearchText(item);
//     return normalizedKeywords.some((keyword) => text.includes(keyword));
//   });

//   // Fallback to full list to avoid blocking posting flows due to naming differences.
//   return filtered.length > 0 ? filtered : subCategories;
// };

const KEYWORDS = {
    PAYMENT_VOUCHER_DISBURSEMENT: [
        "cash",
        "bank",
        "wallet",
        "mobile",
        "mpesa",
        "petty cash",
    ],
    CLIENT_RECEIPT_SETTLEMENT: [
        "cash",
        "bank",
        "wallet",
        "mobile",
        "mpesa",
        "petty cash",
    ],
};

const resolveSearchText = (item = {}) => {
    const category =
        item.accountCategory ||
        item.categoryName ||
        item.category ||
        "";

    const subCategory =
        item.accountCategoryName ||
        item.subCategory ||
        "";

    return normalize(`${category} ${subCategory}`);
};

export const filterAccountSubCategoriesByUseCase = (
    subCategories = [],
    useCase
) => {
    if (!Array.isArray(subCategories)) {
        return [];
    }

    // Purchase Invoice Lines: filter by Account Category ID
    if (useCase === "PURCHASE_INVOICE_LINE") {
        return subCategories.filter(
            (item) => item.accountCategoryId === 11
        );
    }

    const keywords = KEYWORDS[useCase] || [];

    if (keywords.length === 0) {
        return subCategories;
    }

    const normalizedKeywords = keywords.map(normalize);

    const filtered = subCategories.filter((item) => {
        const text = resolveSearchText(item);
        return normalizedKeywords.some((keyword) => text.includes(keyword));
    });

    // Fallback to full list to avoid blocking posting flows due to naming differences.
    return filtered.length > 0 ? filtered : subCategories;
};

